




















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class ProgressBar extends Vue {
  @Prop({ type: Number, default: 0 })
  private readonly percentComplete!: number;

  private get noProgressMade(): boolean {
    return this.percentComplete === 0;
  }
}
